'use client'

import { useEffect } from 'react'

import { AlertTriangle } from 'lucide-react'

import { Button } from '@/components/ui/button'

interface GlobalErrorProps {
	error: Error & { digest?: string }
	reset: () => void
}

export default function GlobalError({ error, reset }: GlobalErrorProps) {
	useEffect(() => {
		// Log error to monitoring service
		console.error('Global error:', error)
	}, [error])

	return (
		<html lang="es">
			<body>
				<div className="bg-background flex min-h-dvh flex-col items-center justify-center p-8">
					<div className="text-center">
						<AlertTriangle className="text-destructive mx-auto h-16 w-16" />
						<h1 className="mt-6 text-4xl font-bold">Error crítico</h1>
						<p className="text-muted-foreground mt-4 text-lg">
							Ha ocurrido un error inesperado en la aplicación.
						</p>
						{process.env.NODE_ENV === 'development' && error.message && (
							<pre className="bg-muted mt-4 max-w-2xl overflow-auto rounded-lg p-4 text-left text-sm">
								{error.message}
							</pre>
						)}
						<div className="mt-8 flex justify-center gap-4">
							<Button onClick={reset}>Intentar de nuevo</Button>
							<Button variant="outline" onClick={() => (window.location.href = '/')}>
								Volver al inicio
							</Button>
						</div>
					</div>
				</div>
			</body>
		</html>
	)
}
